import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_2 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_3 = { class: "d-block mt-2" }

import { ref } from 'vue'
import Simplemde from './Simplemde.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CommentCreation',
  props: {
    showCommentForm: { type: Boolean, default: true },
    createComment: {},
    onCancel: {},
    onOpen: {}
  },
  setup(__props: any) {

const props = __props

const newComment = ref('')

const onCreateComment = async () => {
  // Require content validation
  if (!newComment.value || newComment.value.trim() === '') {
    return
  }

  await props.createComment(newComment.value)

  newComment.value = ''
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (!__props.showCommentForm)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_col, {
          cols: "12",
          class: "p-0 pb-2 pt-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { color: "primary" }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-comment-plus", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }),
            _createElementVNode("a", {
              class: "comment-add-link",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.onOpen && __props.onOpen(...args)))
            }, "コメントを追加…")
          ]),
          _: 1 /* STABLE */
        })
      ]))
    : (__props.showCommentForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "p-0 pb-2"
          }, {
            default: _withCtx(() => [
              _createVNode(Simplemde, {
                modelValue: newComment.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newComment).value = $event)),
                rows: 3,
                name: "comment-body-new"
              }, null, 8 /* PROPS */, ["modelValue"]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  class: "mb-2 me-2",
                  onClick: onCreateComment
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("コメントを送信する", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_btn, { onClick: __props.onCancel }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode("キャンセル", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
              ])
            ]),
            _: 1 /* STABLE */
          })
        ]))
      : _createCommentVNode("v-if", true)
}
}

})